import apiClient from "src/utils/apiClient";
import {
  SearchContainersRequest,
  SearchContainersResponse,
  AddItemToContainerInput,
  AddItemToContainerResponse,
} from "src/types/containerTypes";

/** POST /containers/search */
export const searchContainers = async (
  payload: SearchContainersRequest,
): Promise<SearchContainersResponse> => {
  const response = await apiClient.post<SearchContainersResponse>("/containers/search", payload);
  return response.data;
};

/** POST /containers/add-item-to-container */
export const addItemToContainer = async (
  payload: AddItemToContainerInput,
): Promise<AddItemToContainerResponse> => {
  const response = await apiClient.post<AddItemToContainerResponse>(
    "/containers/add-item-to-container",
    payload,
  );
  return response.data;
};
